<template>
  <v-container fluid>
    <notifications group="actions"></notifications>
    <h2 class="display-1 font-weight-light">Job Market</h2>
    <v-flex>
      <v-row>
        <v-col cols="3">
          <v-autocomplete v-model="searchTerm" :items="listAvailableKeywords" item-text="jobKeywordName" item-value="jobKeywordName" label="Search by keyword"></v-autocomplete>
        </v-col>
        <v-col cols="6">
          <h5 class="">Select a city</h5>
          <v-chip-group v-model="city">
            <v-chip v-for="(city, key) in listAvailableCities" :key="key" :value="city.city" filter small :active-class="'primary--text'">{{city.city}}</v-chip>
          </v-chip-group>
        </v-col>
        <v-col>
          <v-btn color="primary" @click="loadJobOffers(searchTerm, city)" :disabled="searchTerm === null || city === null">Get report</v-btn>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" :sm="12" :md="6" :lg="6">
          <chart-card-container icon="mdi-account-cash" title="Salaries">
            <template slot="chart">
              <salaries-line :job-keyword="jobKeyword" :height="210" v-if="this.jobKeyword"></salaries-line>
            </template>
          </chart-card-container>
        </v-col>
        <v-col cols="12" :sm="12" :md="6" :lg="6">
          <chart-card-container icon="mdi-domain" title="Top 10 companies with active offers">
            <template slot="chart">
              <job-offers-per-company-bars :jobOffers="jobOffers" v-if="jobOffers">
                <v-progress-circular
                  indeterminate
                  color="primary"
                  v-if="loadingJobOffers"
                ></v-progress-circular>
              </job-offers-per-company-bars>
            </template>
          </chart-card-container>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="6" :sm="12" :md="6" :lg="6">
          <chart-card-container icon="mdi-briefcase-arrow-up-down-outline" title="Job offers metrics">
            <template #chart>
              <job-offers-counters :job-offers-counters="jobOffersCounters" v-if="jobOffersCounters" />
            </template>
          </chart-card-container>
        </v-col>

        <v-col cols="6" :sm="12" :md="6" :lg="6">
          <chart-card-container icon="mdi-tag" title="Job offers last weeks">
            <template slot="chart">
              <job-offers-per-week-bars :histogram="jobOffersHistogram" v-if="jobOffersHistogram">
                <v-progress-circular
                  indeterminate
                  color="primary"
                  v-if="loadingJobOffers"
                ></v-progress-circular>
              </job-offers-per-week-bars>
            </template>
          </chart-card-container>
        </v-col>
      </v-row>
    </v-flex>
  </v-container>
</template>

<script>
  import  api from '@/api/index';
  import ProfileJobOffers from "../../components/TabContents/profileJobOffers";
  import ChartCardContainer from "../../components/Charts/chartCardContainer";
  import JobOffersPerWeekBars from "../../components/Charts/Profile/jobOffersPerWeekBars";
  import JobOffersPerLocationBubbles from "../../components/Charts/Profile/jobOffersPerLocationBubbles";
  import JobOffersPerPortalBars from "../../components/Charts/Profile/jobOffersPerPortalBars";
  import JobOffersPerCompanyBars from "../../components/Charts/Profile/jobOffersPerCompanyBars";
  import SalariesLine from "../../components/Charts/Profile/salariesLine";
  import JobOffersCounters from "../../components/Charts/Profile/JobOffersCounters";

  export default {
    name: "jobMarketList",
    components: {
      JobOffersCounters,
      SalariesLine,
      JobOffersPerCompanyBars,
      JobOffersPerPortalBars,
      JobOffersPerLocationBubbles, JobOffersPerWeekBars, ChartCardContainer, ProfileJobOffers},
    data() {
      return {
        searchTerm: null,
        city: null,
        jobOffers: [],
        jobOffersHistogram: [],
        listAvailableKeywords: [],
        listAvailableCities: [],
        jobKeyword: null,
        loadingJobKeyword: false,
        loadingJobOffers: false,
        jobOffersCounters: null
      }
    },
    mounted(){
      this.loadAvailableJobOffersKeywords();
      this.loadAvailableJobOffersCities();
    },
    methods: {
      loadAvailableJobOffersKeywords() {
        api.jobKeywords.getListOfJobKeywordsNames()
          .then(response => {
            this.listAvailableKeywords = response.data.data.jobKeywords.map(e => ({jobKeywordName: e.name}));
          })
      },
      loadAvailableJobOffersCities() {
        api.jobKeywords.getListOfJobKeywordsCities()
          .then(response => {
            this.listAvailableCities = response.data.data.cities;
          })
      },
      loadJobOffers(keyword, city) {
        this.loadingJobKeyword = true;
        this.loadingJobOffers = true;
        const jobSearchTerm = `${keyword} ${city}`
        api.jobOffers.getJobOffersStatsByJobSearchTerm({keyword, city, jobSearchTerm})
          .then(response => {
            this.loadingJobOffers = false;
            this.jobOffers = response.data.data.jobOffers;
            this.jobOffersHistogram = response.data.data.jobOffersStats;
          });
        api.jobKeywords.searchKeywordByNameAndCity({keyword, city})
        .then(response => {
          this.loadingJobKeyword = false;
          this.jobKeyword = response.data.data.jobKeyword;
        })
        this.loadJobOffersCounters(jobSearchTerm)
      },
      loadJobOffersCounters(jobSearchTerm) {
        api.jobOffers.getJobOfferCounters({jobSearchTerm})
          .then(response => {
            this.jobOffersCounters = response.data.data;
          })
      },
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/job-market/List.vue